<!-- INSERT LIBS HERE -->
<p-toast position="top-right" key="SUCCESS_RENIT_PASSWORD"></p-toast>
<lib-lib-accueil [configuration]="configuration" [menuConfig]="menuConfig" *ngIf="menuConfig" [showBlocRemb] = showBlocRemb></lib-lib-accueil>
